import { render, staticRenderFns } from "./Select.vue?vue&type=template&id=8b3da418&scoped=true"
import script from "./Select.js?vue&type=script&lang=js&external"
export * from "./Select.js?vue&type=script&lang=js&external"
import style0 from "./Select.vue?vue&type=style&index=0&id=8b3da418&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b3da418",
  null
  
)

export default component.exports